export enum PlanActionType {
    CREATE_PLAN = 'CREATE_PLAN',
    SET_CREATE_PLAN_ERROR = 'SET_CREATE_PLAN_ERROR',
    SET_CREATE_PLAN_LOADING = 'SET_CREATE_PLAN_LOADING',
    GET_PLANS = 'GET_PLANS',
    SET_PLANS = 'SET_PLANS',
    GET_PLAN_BY_ID = 'GET_PLAN_BY_ID',
    SET_PLAN_BY_ID = 'SET_PLAN_BY_ID',

    UPDATE_PLAN = 'UPDATE_PLAN',
    DELETE_PLAN = 'DELETE_PLAN'
}
